import api from './api';

export const getExtraPaymentToEdit = async (id) => {
    try {
        const response = await api.get(`/api/overtime/getExtraPaymentToEdit/${id}`);
        return response.data;
    } catch (error) {
        return {};
    }
};

export const updateExtraPayment = async (formData) => {
    try {
        const response = await api.put('/api/overtime/updateExtraPayment', formData);
        return response.data;
    } catch (error) {
        return { result: false };
    }
};